<template>
  <v-card
    outlined
    class="my-2 referral-card grey lighten-4"
    :href="getTicket.wa_source_url"
    target="_blank"
    rel="noopener noreferrer"
  >
    <v-card-text class="pa-2">
      <div class="text-caption grey--text text-uppercase font-weight-bold mb-1">
        <v-icon x-small color="grey">fas fa-ad</v-icon>
        Anuncio
      </div>
      <span v-if="getTicket.wa_headline" class="font-weight-bold text--primary">
        {{ getTicket.wa_headline }}
      </span>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TicketCardAd",
  computed: {
    ...mapGetters(["getTicket"]),
  },
};
</script>
